import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ModalController, NavController, PopoverController } from '@ionic/angular';

import { Storage } from '@ionic/storage-angular';

import { MdlReportesDescargablesPage } from 'src/app/pages/mdl-reportes-descargables/mdl-reportes-descargables.page';
import { MasivosService } from 'src/app/services/masivos.service';

@Component({
  selector: 'app-menu-masivos-popover',
  templateUrl: './menu-masivos-popover.component.html',
  styleUrls: ['./menu-masivos-popover.component.scss'],
})
export class MenuMasivosPopoverComponent implements OnInit {

  idAdmin: any;
  storageUsuario: any;
  menu = { plantillas: false, informes: false };
  mostrarReporteEncuestas = false;
  mostrarMasivos: boolean;
  mostrarReportePlantillas = false;

  constructor(
    private navCtrl: NavController,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private storage: Storage,
    private masivosService: MasivosService
  ) { }

  ngOnInit() {
    this.storage.get('usuario').then((usuario) => {
      this.storageUsuario = usuario;
    })
      .then(() => {
        this.idAdmin = this.storageUsuario.idAdmin;
      });
  }

  toggleMenu(menuName: string) {
    const isMenuCurrentlyOpen = this.menu[menuName];

    this.menu = {
      plantillas: false,
      informes: false
    };

    if (!isMenuCurrentlyOpen) {
      this.menu[menuName] = true;
    }
  }

  async closePopover() {
    await this.popoverController.dismiss();
  }

  ir(ruta: string) {
    this.navCtrl.navigateForward('/folder/' + ruta).then(() => {
      if (ruta === 'inicio') {
        window.location.reload();
      }
      this.closePopover();
    });
  }

  async modalReportes() {
    const modal = await this.modalController.create({
      component: MdlReportesDescargablesPage,
      cssClass: 'animate__animated animate__slideInRight',
      showBackdrop: false,
      mode: 'ios',
      componentProps: {
        idAdmin: this.idAdmin,
      },
    });
    this.closePopover();
    return await modal.present();
  }

  toggleReporteEncuestas() {
    this.masivosService.setMostrarReporteEncuestas(true);
    this.masivosService.setMostrarReportePlantillas(false);
    this.masivosService.setMostrarMasivos(false);
    this.closePopover();
  }

  toggleReportePlantillas() {
    this.masivosService.setMostrarReporteEncuestas(false);
    this.masivosService.setMostrarReportePlantillas(true);
    this.masivosService.setMostrarMasivos(false);
    this.closePopover();
  }
}
